import { AvailableLanguage } from '../../types';
import en from './en.json';
import fr from './fr.json';
import nl from './nl.json';

export const locales = { fr, en, nl } as Record<
  AvailableLanguage,
  Record<string, string>
>;
